// Modal Box
export const setModalOpen = '@myteam/setModalOpen';
export const setModalType = '@myteam/setModalType';
// All items
export const setItems = '@myteam/setItems';
// Current Selected Item
export const setSelectedItem = '@myteam/setSelectedItem';
export const setSelectedId = '@myteam/setSelectedId';
export const setSelectedProfileImage = '@myteam/setSelectedProfileImage';
export const setPermissions = '@myteam/setPermissions';
// Items Status
export const setTemplateType = '@myteam/setTemplateType';
// Pagination
export const setCurrentPage = '@myteam/setCurrentPage';
export const setItemsPerPage = '@myteam/setItemsPerPage';
export const setPaginationMeta = '@myteam/setPaginationMeta';
// Reload
export const setReload = '@myteam/setReload';

export const setSearchText = '@myteam/setSearchText';
